import { apiGetClient, apiPostClient, apiPutClient } from "../../api/apiSvtAdmin";
import { toast } from "react-toastify";
import i18n from "i18next";
const t = i18n.t.bind(i18n);

/**
 * Fetch all  users
 */
export const getExternalUserList = async () => {
  try {
    const response = await apiGetClient.get("/external-users");
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || "Failed to fetch users.", { position: "top-center" });
    return null;
  }
};

/**
 * Create a new user
 * @param {Object} data - { email, firstName, lastName, comments }
 */
export const createNewUser = async (data) => {
  try {
    const response = await apiPostClient.post("/external-users/add", data);
    if (response?.data?.data) {
  toast.success(t("externalUserAddedSuccess", { email: data.email }), { position: "top-center" });
      return response.data;
    } else {
      toast.error(t("unexpectedServerResponse"), { position: "top-center" });
      return null;
    }
  } catch (error) {
    const errorData = error.response?.data;
    if (errorData?.errors) {
      Object.keys(errorData.errors).forEach((field) => {
        errorData.errors[field].forEach((message) => {
          toast.error(message, { position: "top-center" });
        });
      });
    } else {
      toast.error(t("failedToCreateUserError", { email: data.email }), { position: "top-center" });
    }
    return null;
  }
};

/**
 * Update an existing administrator
 * @param {Object} data - Updated fields: { email, firstName, lastName, comments }
 * @param {string} userId - ID of the user to update
 */

/**
 * Revoke an administrator
 * @param {string} userId - ID of the user to revoke
 *  @param {string} email - Email of the user to display in the message
 */
export const revokeUser = async (userId, email) => {
  try {
    const response = await apiPutClient.put(`/external-users/delete/${userId}`);
  toast.success(t("externalUserRevokedSuccess", { email }), { position: "top-center" });
    return response.data;
  } catch (error) {
    const errorData = error.response?.data;
    if (errorData?.errors) {
      Object.keys(errorData.errors).forEach((field) => {
        errorData.errors[field].forEach((message) => {
          toast.error(message, { position: "top-center" });
        });
      });
    } else {
      toast.error(errorData?.error || "Error revoking user.", { position: "top-center" });
    }
    return null;
  }
};  